"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getEvents_1 = __importDefault(require("./src/getEvents"));
var makePolygons_1 = __importDefault(require("./src/makePolygons"));
var eventIndex_1 = require("./src/eventIndex");
function union(collection, originalIdProperty) {
    var _a;
    var _b = getEvents_1.default(collection, originalIdProperty), events = _b.events, interiorRings = _b.interiorRings, independentFeatures = _b.independentFeatures;
    var index = new eventIndex_1.EventIndex(events);
    var outputCollection = makePolygons_1.default(collection, index, interiorRings);
    (_a = outputCollection.features).push.apply(_a, independentFeatures);
    return outputCollection;
}
exports.union = union;
